
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Bien rédiger les mentions légales pour son site internet",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Dans l'univers digital en constante évolution, la création et la gestion d'un site internet sont devenues des étapes cruciales pour les entreprises de toutes tailles.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Bien rédiger les mentions légales pour son site internet",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Dans l'univers digital en constante évolution, la création et la gestion d'un site internet sont devenues des étapes cruciales pour les entreprises de toutes tailles.",
        },
      ],
    };
  },
};
